// One stack shared by portalled dialogs and the Telegram navigation bridge.
const layers = [];
const listeners = new Set();
const changed = () => listeners.forEach(listener => listener());
export const subscribeBackLayers = listener => { listeners.add(listener); return () => listeners.delete(listener); };
export const backLayerCount = () => layers.length;
export function registerBackLayer(close) {
  const layer = { close };
  layers.push(layer); changed();
  return () => { const index = layers.indexOf(layer); if (index >= 0) { layers.splice(index, 1); changed(); } };
}
export function dismissBackLayer() {
  const top = layers.at(-1);
  if (!top) return false;
  top.close();
  return true;
}
